module.exports = __webpack_public_path__ + "img/empty-track-light.02c24bc8.png";